import FqApi from '@/services/fq-api'
import { BYTES_PER_MB } from '@/services/byteUnits'

/**
 * PCK-213 - the total email attachment cap, read from the API instead of hardcoded.
 *
 * The cap used to be written into VueEmail and PrintPreview as `25 * 1024 * 1024`, which
 * disagreed with what the server actually enforced, so the composer would happily accept an
 * email the send path then rejected. It now comes from a single Setting row that both ends read.
 *
 * Memoised because two components ask for it and the composer can be opened repeatedly; the cap
 * does not change within a page load.
 *
 * The fallback is deliberately a real limit rather than 0 or Infinity - one would block every
 * email, the other would block none. It matches MailgunService.DEFAULT_ATTACHMENT_TOTAL_SIZE_MB,
 * so an unreachable API degrades to the same number the server falls back to. The server is the
 * authority either way: it names the true limit in its rejection message.
 */

export const FALLBACK_MAX_TOTAL_BYTES = 15 * BYTES_PER_MB

let cached = null

export function getMaxTotalAttachmentBytes() {
  if (!cached) {
    cached = FqApi.get('/settings/emailattachmentlimit')
      .then((response) => {
        const bytes = response && response.data ? Number(response.data.maxTotalBytes) : NaN
        return Number.isFinite(bytes) && bytes > 0 ? bytes : FALLBACK_MAX_TOTAL_BYTES
      })
      .catch(() => FALLBACK_MAX_TOTAL_BYTES)
  }
  return cached
}

/** Test seam - drops the memoised result so each spec starts clean. */
export function resetEmailLimitsCache() {
  cached = null
}

export default { getMaxTotalAttachmentBytes, resetEmailLimitsCache, FALLBACK_MAX_TOTAL_BYTES }
